<template>
  <div id="tags-view-container" class="tags-view-container">
    <el-tabs v-model="activeTab" @tab-change="changeTab" @tab-remove="removeTab" type="card">
      <el-tab-pane v-for="item in visitedViews" :key="item.path" :label="item.meta.title" :name="item.path" :closable="item.path !== '/dashboard'"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {useRouterStore} from "@/store/router";
import {useRoute} from "vue-router";
import {useRouter} from "vue-router";
import {computed, watch, ref, onMounted} from "vue";
export default {
  name: "TagView",
  setup() {

    const routerStore = useRouterStore()
    const route = useRoute()
    const router = useRouter()
    const visitedViews = computed(() => {
      return routerStore.visitedViews
    })
    const activeTab = ref(route.path)
    watch(route, () => {
      activeTab.value = route.path
      addTags()
    })
    onMounted(() => {
      addTags()
    })
    const addTags = () => {
      routerStore.addView({
        path: '/dashboard',
        name: 'dashboard',
        meta: {
          title: '首页',
        },
      })
      const { path } = route
      if (path) {
        routerStore.addView(route)
      }
      return false
    }

    const removeTab = (path) => {
      if (path && path !== '/dashboard') {
        if (path === activeTab.value) {
          const currentIndex = visitedViews.value.findIndex(item => item.path === path)
          const nextTab = visitedViews.value[currentIndex + 1] || visitedViews.value[currentIndex - 1]
          router.push(nextTab.path)
        }
        routerStore.removeView(path)
      }
    }

    const changeTab = () => {
      router.push(activeTab.value)
    }

    return {
      visitedViews, activeTab, removeTab, changeTab,
    }
  }
}
</script>

<style scoped>
.tags-view-container {
  height: 40px;
  width: 100%;
  background: #fff;
  /*padding: 0 10px;*/
}
</style>